import { authService } from "@/features/auth/services/authService";
import { userService } from "@/features/profile/services/userService";
import { LOCAL_STORAGE } from "@/config/constants";
import { getLocal } from "@/helpers/localStore";
import { logger } from "@/helpers/loggerHelper";

type UserId = string | number | null | undefined;

export const reportUserActivity = async (event = ""): Promise<void> => {
  try {
    await userService.userActivity(event);
  } catch (err) {
    logger.error("Error in reportUserActivity", { err });
  }
};

export const reportOpenLogout = async (userId: UserId): Promise<void> => {
  try {
    const jwt_token = getLocal(LOCAL_STORAGE.TOKEN_NAME);
    if (userId == null || jwt_token == null || jwt_token === "") return;
    await authService.openLogout({
      userId: String(userId),
      jwt_token,
    });
  } catch (err) {
    logger.error("Error in reportOpenLogout", { err });
  }
};
